export default __webpack_public_path__ + "static/media/id-placeholder.8f431660.svg";